module.exports = __webpack_public_path__ + "static/media/sm.07272ce1.png";